import { render, staticRenderFns } from "./AssessmentBatchData.vue?vue&type=template&id=3fe27d9a"
import script from "./AssessmentBatchData.vue?vue&type=script&lang=js"
export * from "./AssessmentBatchData.vue?vue&type=script&lang=js"
import style0 from "./AssessmentBatchData.vue?vue&type=style&index=0&id=3fe27d9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports